export default "__VITE_ASSET__481dac78__"